export class ValidationResult {
  private errorMessages: Array<string> = [];

  public addErrorMessage(errorMessage: string): void {
    this.errorMessages.push(errorMessage);
  }

  public getErrorMessage(): string {
    return this.errorMessages[0];
  }

  public hasErrorMessages(): boolean {
    return this.errorMessages.length > 0;
  }
}
